import { cn } from "@/lib/utils";
import { ExtensionLink } from "components/core/ExtensionLink";
import { CogIcon } from "lucide-react";
import { AppPage } from "models/AppPage";

interface DropdownItemProps {
    child: AppPage;
    isSelected: boolean;
    animationDelay: string;
    onSettingsClick?: (e: React.MouseEvent) => void;
}

/**
 * Individual dropdown menu item component
 * Displays a single navigation link with selection state and animations
 */
export const DropdownItem = ({
    child,
    isSelected,
    animationDelay,
    onSettingsClick
}: DropdownItemProps) => {
    const isSettingsItem = (child as any).isSettings;

    if (isSettingsItem) {
        return (
            <button
                onClick={onSettingsClick}
                className="group/item relative cursor-pointer overflow-hidden
                    rounded-lg"
                style={{
                    animation: `fadeInUp 0.5s cubic-bezier(0.16, 1, 0.3, 1) ${animationDelay} backwards`
                }}
                aria-label="관심 주제 편집"
            >
                <div
                    className={cn(
                        "relative w-[130px] px-4 py-3 text-sm font-medium",
                        "rounded-xl transition-all duration-300 ease-out",
                        `hover:bg-black/70 hover:text-white
                        dark:hover:bg-white/70 dark:hover:text-black`
                    )}
                >
                    <div
                        className="relative z-10 flex items-center
                            justify-center gap-2 text-center tracking-normal"
                    >
                        <CogIcon size={16} /> 설정
                    </div>
                </div>
            </button>
        );
    }

    return (
        <ExtensionLink
            href={child.href}
            className="group/item relative cursor-pointer overflow-hidden
                rounded-lg"
            style={{
                animation: `fadeInUp 0.5s cubic-bezier(0.16, 1, 0.3, 1) ${animationDelay} backwards`
            }}
        >
            <div
                className={cn(
                    "relative w-[130px] px-4 py-3 text-sm font-medium",
                    "rounded-xl transition-all duration-300 ease-out",
                    isSelected
                        ? "bg-black text-white dark:bg-white dark:text-black"
                        : `hover:bg-black/70 hover:text-white
                            dark:hover:bg-white/70 dark:hover:text-black`
                )}
            >
                <div
                    className="relative z-10 flex items-center justify-center
                        text-center tracking-normal"
                >
                    {child.label}
                </div>
            </div>
        </ExtensionLink>
    );
};
